export default {
  name: "Нэр",
  tel: "Утас",
  save: "аврах",
  confirm: "батлах",
  cancel: "Цуаах",
  delete: "эдгээх",
  complete: "Дуусах",
  loading: "Ачаалах ...",
  telEmpty: "Утасны дугаараа бөглөнө үү",
  nameEmpty: "Нэрээ бөглөнө үү",
  nameInvalid: "Зөв нэр оруулна уу",
  confirmDelete: "Та үүнийг устгахыг хүсч байгаа гэдэгтээ итгэлтэй байна уу?",
  telInvalid: "Зөв утасны дугаарыг оруулна уу",
  vanCalendar: {
    end: "Дуусах",
    start: "эхлэх",
    title: "гарчиг",
    confirm: "батлах",
    startEnd: "Хэлций",
    weekdays: {
      "0": "өдөр",
      "1": "нэг",
      "2": "хоер",
      "3": "гурав",
      "4": "Дөрөв",
      "5": "тав",
      "6": "зургаа"
    }
  },
  vanCascader: { select: "Сонгоно уу" },
  vanContactCard: { addText: "Харилцагч нэмэх" },
  vanContactList: { addText: "Шинэ холбоо барих хүн" },
  vanPagination: { prev: "Одоогийн хуудас", next: "Дараагийн хуудас" },
  vanPullRefresh: {
    pulling: "Сэргээхийн тулд доошоо татна уу ...",
    loosing: "Дахин сэргээнэ үү ..."
  },
  vanSubmitBar: { label: "Бүгд:" },
  vanCoupon: { unlimited: "Хэрэглээний хязгаарлалт байхгүй" },
  vanCouponCell: { title: "Купон", tips: "боломжгүй" },
  vanCouponList: {
    empty: "Купон байхгүй",
    exchange: "солилцох",
    close: "Купон байхгүй",
    enable: "Бэлнээр байгаа",
    disabled: "боломжгүй",
    placeholder: "Хөнгөлөлтийн кодыг оруулна уу"
  },
  vanAddressEdit: {
    area: "талбай",
    postal: "шуудангийн код",
    areaEmpty: "Бүсийг сонго",
    addressEmpty: "Нарийвчилсан хаягийг бөглөнө үү",
    postalEmpty: "Шуудангийн кодын формат буруу байна",
    defaultAddress: "Тээвэрлэлтийн үндсэн хаяг гэж тохируулна уу",
    telPlaceholder: "Хүлээн авагчийн гар утасны дугаар",
    namePlaceholder: "Хүлээн авагчийн нэр",
    areaPlaceholder: "Аймаг / хот / дүүргийг сонгоно уу"
  },
  vanAddressEditDetail: {
    label: "хаяглах",
    placeholder:
      "Гудамжны хаалганы дугаар, шалны өрөөний дугаар болон бусад мэдээлэл"
  },
  vanAddressList: { add: "Хаяг нэмэх" }
};
